import { observer } from "mobx-react";
import { ProjectUsersStore } from "Pages/Admin/Stores/ProjectUsersStore";
import { ProjectMembersEditor } from "./ProjectMembersEditor";
import { Row } from "antd";
import { t } from "i18next";

interface UsersTabProps {
  store: ProjectUsersStore;
}

export const UsersTab = observer(({ store }: UsersTabProps) => {
  return (
    <>
      <Row justify="space-between" align="middle">
        <h1>{t("Members")}</h1>
      </Row>
      <ProjectMembersEditor
        store={store}
        getUserEditUrl={(user) => `/admin/user/edit/${user.id}`}
        tableName="usersTab"
      />
    </>
  );
});
